import {
    REQUEST_DICTIONARIES,
    REQUEST_DICTIONARIES_FULLFILED,
    ABORT_REQUEST_DICTIONARIES,
    THROW_REQUEST_DICTIONARIES_ERROR,
    REQUEST_CREATE_DICTIONARY,
    REQUEST_CREATE_DICTIONARY_FULLFILED,
    THROW_REQUEST_CREATE_DICTIONARY_ERROR,
    UPDATE_DICTIONARIES_LIST
} from "../types";

export const retrieve = (token, query) => {
    return { type: REQUEST_DICTIONARIES, payload: ({ token, query }) };
}

export const update = (code, project) => {
    return { type: UPDATE_DICTIONARIES_LIST, payload: { code, project } };
}

export const fullfiled = (data) => {
    return { type: REQUEST_DICTIONARIES_FULLFILED, payload: data };
}

export const abort = () => {
    return { type: ABORT_REQUEST_DICTIONARIES };
}

export const throwError = (err) => {
    return { type: THROW_REQUEST_DICTIONARIES_ERROR, payload: err };
}

export const create = (token, postId, title, price = 5) => {
    return { type: REQUEST_CREATE_DICTIONARY, payload: ({ token, postId, title, price }) };
}

export const createFullfiled = (data) => {
    return { type: REQUEST_CREATE_DICTIONARY_FULLFILED, payload: data };
}

export const throwCreateDictionaryError = (err) => {
    return { type: THROW_REQUEST_CREATE_DICTIONARY_ERROR, payload: err };
}





// WEBPACK FOOTER //
// ./src/actions/dictionary-actions.js